import Vue from 'vue'

export const POLL_INTERVAL = 7000
export const CLIENT_REPORT_COLUMNS = Object.freeze([
    'id', 'tg_id', 'phone', 'name', 'main_address.address', 'first_open_app', 'birthday',
    'orders_sum', 'orders_count', 'cashback', 'created_at', 'blocked', 'no_cash_payment',
    'first_order_at', 'last_buy_at', 'comment', 'email',
])

export function requestKey() {
    return Array.from(window.crypto.getRandomValues(new Uint32Array(4)), value => value.toString(16).padStart(8, '0')).join('')
}

export async function reportError(error, fallback = 'Не удалось выполнить запрос. Попробуйте ещё раз.') {
    const response = error && error.response
    if (!response) return fallback
    if (response.status === 401) return 'Сессия истекла. Войдите в админку снова.'
    if (response.status === 403) return 'Недостаточно прав для этого отчёта.'
    if (response.status === 404) return 'Отчёт не найден или недоступен.'
    if (response.status >= 500) return fallback
    let data = response.data
    if (data instanceof Blob) {
        try { data = JSON.parse(await data.text()) } catch (_) { data = null }
    }
    if (data && data.errors) {
        const messages = Object.values(data.errors)
        if (messages.length) return Array.isArray(messages[0]) ? messages[0][0] : messages[0]
    }
    return data && data.message ? data.message : fallback
}

export const reportStates = {
    queued: {label: 'В очереди', color: 'grey darken-1', icon: 'mdi-clock-outline'},
    processing: {label: 'Формируется', color: 'blue darken-2', icon: 'mdi-progress-clock'},
    ready: {label: 'Готов к скачиванию', color: 'green darken-2', icon: 'mdi-check-circle-outline'},
    failed: {label: 'Ошибка', color: 'red darken-1', icon: 'mdi-alert-circle-outline'},
    completed: {label: 'Сделано', color: 'grey darken-1', icon: 'mdi-archive-outline'},
}

export default {
    list(params) { return Vue.axios.get('/reports', {params}) },
    get(id) { return Vue.axios.get(`/reports/${encodeURIComponent(id)}`) },
    create(data) { return Vue.axios.post('/reports', data) },
    async download(report) {
        const response = await Vue.axios.get(`/reports/${encodeURIComponent(report.id)}/download`, {
            responseType: 'blob', headers: {Accept: 'application/json'}, timeout: 120000,
        })
        const type = (response.headers['content-type'] || '').split(';')[0].trim().toLowerCase()
        if (!(response.data instanceof Blob) || !response.data.size || ![
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel', 'application/octet-stream',
        ].includes(type)) throw new Error('Invalid report file response')
        const url = window.URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = url
        link.download = (report.filename || 'clients.xlsx').replace(/[/\\]/g, '_')
        document.body.appendChild(link)
        try { link.click() } finally {
            link.remove()
            setTimeout(() => window.URL.revokeObjectURL(url), 1000)
        }
    },
}
